import parsePx from './parsePx.js';

export default function getClientWidth(node) {
  let rect = node.getBoundingClientRect();
  if (rect.width) {
    return rect.width;
  } else if (window.getComputedStyle) {
    return parsePx(getComputedStyle(node).getPropertyValue('width'));
  }
  return node.width;
}



/** WEBPACK FOOTER **
 ** ./src/functions/getClientWidth.js
 **/